import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { BmsjHipsterAppModule } from './app.module';

ProdConfig();

platformBrowserDynamic().bootstrapModule(BmsjHipsterAppModule)
    // eslint-disable-next-line no-console
    .then((success) => console.log('Application started'))
    .catch((err) => console.error(err));
